export default __webpack_public_path__ + "images/2975095a03070215904c962cbb866690-singersongwriter.jpg";